var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-red-500"},[_c('ul',{staticClass:"list-disc"},_vm._l((_vm.messages),function(message,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(message)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }